module.exports = __webpack_public_path__ + "static/media/icon-sum.35dbd52a.svg";